import React from 'react';
import { Box, Heading, Container, HStack, Icon, Link } from '@hover/blueprint';
import { iMail, iPhone } from '@hover/icons';
import { Layout } from '../../../v2/components/common';

const Contact: React.FC = () => (
  <Layout
    title="Contact Us"
    description="If you have any question feel free to contact us via phone or email at any time. We are here to help."
    isNavbarWhite={false}
    navbarBackgroundColor="brandNavy.500"
  >
    <Box
      w="100%"
      bg="brandNavy.500"
      h="264px"
      alignItems="center"
      justifyContent="center"
      mb={1000}
    >
      <Heading
        marginBottom={{ base: 0, desktop: 0 }}
        isLight
        color="neutral.0"
        size={{ base: 600, tablet: 700, desktop: 800 }}
      >
        Contact us
      </Heading>
    </Box>
    <Container maxW="100%" centerContent mt={600} px={500}>
      <Heading
        marginBottom={{ base: 100, tablet: 100 }}
        size={{ base: 300, tablet: 500 }}
      >
        Help us improve HOVER
      </Heading>
      <Heading
        textAlign="center"
        marginBottom={{ base: 1000, tablet: 1000 }}
        isDisplay
        size={{ base: 300, tablet: 500 }}
      >
        Send us questions, complaints, bugs, or feature requests.
      </Heading>
      <Box flexDir="column" alignItems="flex-start">
        <HStack spacing={500} mb={700}>
          <Icon m={0} color="brandNavy.500" size="default" icon={iMail} />
          <Heading
            color="primary.600"
            marginBottom={{ base: 1000, desktop: 1000 }}
            isLight
            size={{ base: 300, tablet: 500 }}
            as={Link}
          >
            <Link href="mailto:support@hover.to">support@hover.to</Link>
          </Heading>
        </HStack>
        <HStack as={Link} spacing={500} mb={400}>
          <Icon m={0} color="brandNavy.500" size="default" icon={iPhone} />
          <Heading
            color="primary.600"
            marginBottom={{ base: 1000, desktop: 1000 }}
            isLight
            size={{ base: 300, tablet: 500 }}
          >
            <Link href="tel:800-754-6837">800-754-6837</Link>
          </Heading>
        </HStack>
      </Box>
      <Heading textAlign="center" marginBottom="236px" isDisplay size={200}>
        Yup, just call us. A human picks up the phone.
      </Heading>
    </Container>
  </Layout>
);

export default Contact;
